/* velora-cart-reset.js — Velora product pages (pumpkinseed · pumpkinseed-bladder · pumpkin-glp1)
 * Every buy button on these pages goes straight to checkout (Kaching skipCart). Shopify's checkout
 * IS the cart (same token), so the cart must never be cleared while a checkout is in progress.
 * Instead the cart is reset at the two moments a stale cart can pile up:
 *   1. when a visitor arrives at / returns to a product page with items already in the cart
 *      (came back from checkout, back-button/bfcache, or a later visit with the same cookie);
 *   2. right before the FIRST add-to-cart on this page view (covers a second tab that already
 *      reached checkout). Later adds in the same page view are left alone (a bundle tier can be
 *      several /cart/add calls).
 *   3. Every secondary buy button on the page scrolls to the quantity selector (the bundle tiers), so the
 *      visitor picks a tier and presses the real add-to-cart button (Guy, 22.09): sticky bar buttons ·
 *      "נסי עכשיו ללא סיכון" (guarantee section) · "אני רוצה לנסות" · the in-page "הוספה לסל" buttons on the esl page.
 *      Before: those either scrolled to the wrong place, reloaded the page, or posted a form that the bundle
 *      app swallowed (0 items). None of them adds to the cart or goes to checkout by itself.
 */
(function () {
  'use strict';
  if (window.__vlrCartReset) return;
  window.__vlrCartReset = true;
  /* product pages only, top window only — never on checkout, cart, or inside an iframe */
  if (window.top !== window || !/\/products\//.test(location.pathname)) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CLEAR = root + 'cart/clear.js';
  var CART = root + 'cart.js';
  var ADD_RX = /\/cart\/add(\.js)?(\?|$)/;
  var clearedThisView = false;
  var clearing = null;
  var nativeFetch = window.fetch;

  function clearCart() {
    if (clearing) return clearing;
    clearing = nativeFetch(CLEAR, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .catch(function () {})
      .then(function () { clearedThisView = true; clearing = null; });
    return clearing;
  }

  /* 1) arrival / return with a non-empty cart */
  function resetIfStale() {
    clearedThisView = false;
    nativeFetch(CART, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count > 0) return clearCart(); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', resetIfStale); /* fires on load AND on bfcache back */

  /* 2) first add-to-cart of this page view: clear first, then let the add go through */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method === 'POST' && ADD_RX.test(url) && !clearedThisView) {
      var args = arguments;
      return clearCart().then(function () { return nativeFetch.apply(window, args); });
    }
    return nativeFetch.apply(window, arguments);
  };
  /* 3) secondary CTAs -> scroll to the quantity selector */
  var ROUTE = '.vlr-ing-cta, .sticky-atc__scroll-btn, .sticky-atc__add_button, [id^="SectionAtcBtn-"], .vesl-cta, [data-vesl-atc], [data-vlr-atc]';
  function selector() {
    return document.querySelector('.kaching-bundles, kaching-bundle, #MainContent product-form, #MainContent form[action*="/cart/add"]');
  }
  function stickyHeaderHeight() {
    var h = document.querySelector('.header-wrapper, header.header, #shopify-section-header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    return (cs.position === 'sticky' || cs.position === 'fixed') ? h.getBoundingClientRect().height : 0;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest(ROUTE);
    if (!t) return;
    var s = selector();
    if (!s) return; /* nothing to scroll to: keep the original behaviour */
    e.preventDefault(); e.stopPropagation();
    var y = s.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }, true);

  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__vlrAdd = String(m).toUpperCase() === 'POST' && ADD_RX.test(String(u)); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__vlrAdd && !clearedThisView) { var x = this, a = arguments; clearCart().then(function () { xSend.apply(x, a); }); return; }
    return xSend.apply(this, arguments);
  };
})();
